import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom"; // Adicione useLocation aqui
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Hero from "./components/Hero";
import Services from "./components/Services";
import About from "./components/About";
import FrasesCarousel from "./components/Carousel";
import Artigo from "./components/Artigo";
import SectionWithText from "./components/SectionWithText";
import SectionWithOne from "./components/SectionWithOne";
import PedrasPage from "./components/PedrasPage";
import CaminhoPage from "./components/Caminho";
import AnsiedadePage from "./components/Ansiedade";
import FrustracaoPage from "./components/Frustracao";
import ProcrastinacaoPage from "./components/Procrastinacao";
import FuturoPage from "./components/Futuro";
import TempoPage from "./components/Tempo";
import AmarPage from "./components/Amar";

const Layout = ({ children }) => {
  const location = useLocation(); // Agora useLocation está definido
  const isSpecialPage =
    location.pathname === "/pedras" ||
    location.pathname === "/caminho" ||
    location.pathname === "/ansiedade" ||
    location.pathname === "/frustracao" ||
    location.pathname === "/procrastinacao" ||
    location.pathname === "/futuro" ||
    location.pathname === "/tempo" ||
    location.pathname === "/amar";

  return (
    <div>
      <Navbar />
      {!isSpecialPage && (
        <>
          <Hero />
          <Services />
          <SectionWithOne>
            <h1 className="text-3xl font-bold text-[#ad6a51] font-mukta-mahee">
              <br /> Olá!
            </h1>
            <p
              className="items-center justify-center mx-4 text-[#ad6a51] font-mukta-mahee text-lg lg:text-xl"
              style={{ lineHeight: "32px" }}
            >
              <br />
              Seja bem-vindo(a) a este espaço!
              <br />
              <br />
              Vamos falar um pouco sobre a psicoterapia?
              <br /> A partir da relação terapêutica, neutra e livre de
              julgamentos, você pode ter um espaço seguro, acolhedor e sigiloso
              para falar abertamente sobre suas angústias e explorar sua
              história de vida.
              <br />
              <br />
              Acredito que, com a psicoterapia, você pode trilhar um caminho que
              lhe ajudará a entender e lidar com suas dores emocionais, com o
              objetivo de te auxiliar a alcançar uma vida mais leve, saudável e
              produtiva. Que você possa, cada vez mais se encontrar consigo e
              com suas potências!
              <br /> <br />
            </p>
          </SectionWithOne>
          <About />
          <FrasesCarousel />
          <SectionWithText>
            <h1 className="text-3xl font-bold mb-4 text-[#ad6a51] font-mukta-mahee">
              O Encontro
            </h1>
            <p className="items-center justify-center mx-4 text-[#ad6a51] font-mukta-mahee text-lg lg:text-xl">
              A psicoterapia é um espaço seguro, onde você pode expressar o que
              sente, explorar sua história e cuidar das suas angústias. Para
              isso, a importância de um ambiente com privacidade e
              tranquilidade, seja na sessão online ou presencial.
              <br />A cada encontro, temos a possibilidade de reler uma página
              de sua história e dar um novo sentido a ela.
              <br />
              Através da fala, podemos abrir espaço para sentimentos e dar um
              novo destino a eles.
              <br />
              Quando você dá vazão às angústias, um espaço dentro de você pode
              se abrir para você se acomodar dentro de si.
            </p>
          </SectionWithText>
        </>
      )}
      {children}
      <Footer />
    </div>
  );
};

const App = () => {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <Layout>
              <Artigo />
            </Layout>
          }
        />
        <Route
          path="/pedras"
          element={
            <Layout>
              <PedrasPage />
            </Layout>
          }
        />
        <Route
          path="/caminho"
          element={
            <Layout>
              <CaminhoPage />
            </Layout>
          }
        />
        <Route
          path="/ansiedade"
          element={
            <Layout>
              <AnsiedadePage />
            </Layout>
          }
        />
        <Route
          path="/frustracao"
          element={
            <Layout>
              <FrustracaoPage />
            </Layout>
          }
        />
        <Route
          path="/procrastinacao"
          element={
            <Layout>
              <ProcrastinacaoPage />
            </Layout>
          }
        />
        <Route
          path="/futuro"
          element={
            <Layout>
              <FuturoPage />
            </Layout>
          }
        />
        <Route
          path="/tempo"
          element={
            <Layout>
              <TempoPage />
            </Layout>
          }
        />
        <Route
          path="/amar"
          element={
            <Layout>
              <AmarPage />
            </Layout>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
